<template>
    <div>
        Chào mừng bạn
    </div>
</template>
